import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, finalize } from "rxjs";
import { LoadingService } from "../LoadingService/loading.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})
export class ApiRequestService {
 // BASE_URL = environment.BASE_URL;
 
 BASE_URL = environment.APPLICATION_BASEURL;
  constructor(
    private http: HttpClient,
     private loaderService: LoadingService,
     ) {
  }  // Inject LoaderService
  

  postRequest<T>(uri: string, payload: any): Observable<HttpResponse<T>> {
    this.loaderService.showLoader();  // Show loader
    return this.http.post<T>(`${uri}`, payload, { observe: 'response' }).pipe(
      finalize(() => this.loaderService.hideLoader())  // Hide loader after request finishes
    );
  }
  
  getRequest<T>(uri: string, params?: any,  headers?: any,autoHideLoader: boolean = true): Observable<HttpResponse<T>> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }
  
    this.loaderService.showLoader();  
    const httpHeaders = new HttpHeaders(headers || {});
    return this.http.get<T>(`${uri}`, { observe: 'response', params: httpParams }).pipe(
      finalize(() => {
        if (autoHideLoader) {
          this.loaderService.hideLoader();  
        }
      })
    );
  }
  

  updateRequest<T>(uri: string, data: any): Observable<HttpResponse<T>> {
    this.loaderService.showLoader();  // Show loader
    return this.http.put<T>(`${uri}`, data, { observe: 'response' }).pipe(
      finalize(() => this.loaderService.hideLoader())  // Hide loader after request finishes
    );
  }
  updateResourceRequest<T>(uri: string, data?: any,id? : number ): Observable<HttpResponse<T>> {
    this.loaderService.showLoader();  // Show loader
    return this.http.put<T>(`${uri}/${id}`, data, { observe: 'response' }).pipe(
      finalize(() => this.loaderService.hideLoader())  // Hide loader after request finishes
    );
  }
  patchRequest<T>(uri: string, data: any): Observable<HttpResponse<T>> {
    this.loaderService.showLoader();  // Show loader
    return this.http.patch<T>(`${uri}`, data, { observe: 'response' }).pipe(
      finalize(() => this.loaderService.hideLoader())  // Hide loader after request finishes
    );
  }

  deleteRequest<T>(uri: string, data = {}): Observable<HttpResponse<T>> {
    this.loaderService.showLoader();  // Show loader
    return this.http.delete<T>(`${uri}`, { observe: 'response', body: data }).pipe(
      finalize(() => this.loaderService.hideLoader())  // Hide loader after request finishes
    );
  }

  // Special method for Face/verify endpoint that returns plain text
  postRequestText(uri: string, payload: any): Observable<HttpResponse<string>> {
    this.loaderService.showLoader();
    return this.http.post(`${uri}`, payload, { 
      observe: 'response', 
      responseType: 'text' 
    }).pipe(
      finalize(() => this.loaderService.hideLoader())
    );
  }

  // Special method for Face/delete endpoint that accepts FormData and returns plain text
  deleteRequestText(uri: string, payload: any): Observable<HttpResponse<string>> {
    this.loaderService.showLoader();
    return this.http.delete(`${uri}`, { 
      observe: 'response', 
      responseType: 'text',
      body: payload 
    }).pipe(
      finalize(() => this.loaderService.hideLoader())
    );
  }

  // Special method for RemoveOldRegisterDevice endpoint that returns boolean
  removeOldRegisterDevice(userId: number): Observable<HttpResponse<boolean>> {
    this.loaderService.showLoader();
    return this.http.put<boolean>(`User/RemoveOldRegisterDevice/${userId}`, {}, { observe: 'response' }).pipe(
      finalize(() => this.loaderService.hideLoader())
    );
  }

  // Method to get user data by userId
  getUserById(userId: number): Observable<HttpResponse<any>> {
    this.loaderService.showLoader();
    return this.http.get<any>(`User/${userId}`, { observe: 'response' }).pipe(
      finalize(() => this.loaderService.hideLoader())
    );
  }
}
